import { ChangeEvent, FC, PropsWithChildren } from 'react';
import styled from 'styled-components';

import { Label } from './Forms';

const StyledLabel = styled(Label)<{ $disabled?: boolean }>`
  position: relative;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
  user-select: none;
  margin: 0;
  padding-left: 25px;
`;

const Checkmark = styled.span`
  width: 16px;
  height: 16px;
  top: 0;
  bottom: 0;
  left: 0;
  margin: auto 0;
  position: absolute;
  border: 2px solid ${({ theme }) => theme.colors.gray};
  border-radius: 1px;
  transition: 0.2s ease-out all;
  &::after {
    content: '';
    position: absolute;
    left: 4px;
    top: 1px;
    width: 5px;
    height: 9px;
    border: solid ${({ theme }) => theme.colors.white};
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    display: none;
  }
`;

const Input = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 1px;
  width: 1px;
  &:checked ~ ${Checkmark} {
    background: ${({ theme }) => theme.colors.purple};
    border-color: ${({ theme }) => theme.colors.purple};
    &::after {
      display: block;
    }
  }
`;

interface Props {
  checked: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

const Checkbox: FC<PropsWithChildren<Props>> = ({
  checked,
  children,
  onChange,
  disabled,
}) => {
  return (
    <StyledLabel $disabled={disabled}>
      {children}
      <Input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <Checkmark />
    </StyledLabel>
  );
};

export default Checkbox;
